import { gql } from '@apollo/client';

export const GET_APP_AUTH_IMAGES = gql`
  query GetAppAuthImages {
    appAuthImage {
      images {
        url
        formats
      }
    }
  }
`;
